import { render, staticRenderFns } from "./TileDataContent.vue?vue&type=template&id=2e80b8ed"
import script from "./TileDataContent.vue?vue&type=script&lang=js"
export * from "./TileDataContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports